<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.ImageId") }}:
          </span>
          <span class="expand-value">{{ row.imageId }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.amazonVpcId") }}
          </span>
          <span class="expand-value">{{ row.amazonVpcId }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.OperatingSystem") }}:
          </span>
          <span class="expand-value">{{ row.os }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.InstanceStatus") }}:
          </span>
          <span class="expand-value">{{ row.stateName }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.Project") }}:
          </span>
          <span class="expand-value">{{ row.project }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.Owner") }}:
          </span>
          <span class="expand-value">{{ row.owner }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.PublicIP") }}:
          </span>
          <span class="expand-value">{{ row.publicIp }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.PrivateIP") }}:
          </span>
          <span class="expand-value">{{ row.privateIp }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key"
            >{{ $t("RAM.ALI.computeInstance.InstanceCreatedTime") }}:
          </span>
          <span class="expand-value">{{ row.instanceCreatedTime }}</span>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/ecs/TableExpand.vue